/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An addenda record to be added to an ACH transfer
 */
export type CreateTransferACHAddendaRecord = {
  /**
   * The raw ACH addenda record. Must only contain valid NACHA characters
   */
  record: string;
};

/** @internal */
export const CreateTransferACHAddendaRecord$inboundSchema: z.ZodType<
  CreateTransferACHAddendaRecord,
  z.ZodTypeDef,
  unknown
> = z.object({
  record: z.string(),
});
/** @internal */
export type CreateTransferACHAddendaRecord$Outbound = {
  record: string;
};

/** @internal */
export const CreateTransferACHAddendaRecord$outboundSchema: z.ZodType<
  CreateTransferACHAddendaRecord$Outbound,
  z.ZodTypeDef,
  CreateTransferACHAddendaRecord
> = z.object({
  record: z.string(),
});

export function createTransferACHAddendaRecordToJSON(
  createTransferACHAddendaRecord: CreateTransferACHAddendaRecord,
): string {
  return JSON.stringify(
    CreateTransferACHAddendaRecord$outboundSchema.parse(
      createTransferACHAddendaRecord,
    ),
  );
}
export function createTransferACHAddendaRecordFromJSON(
  jsonString: string,
): SafeParseResult<CreateTransferACHAddendaRecord, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateTransferACHAddendaRecord$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateTransferACHAddendaRecord' from JSON`,
  );
}
